import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Tabs, useMantineTheme, Box } from '@mantine/core';

const WrapperTab = ({ children, stateNavigate, stateKeepMounted = false }) => {

    const navigate = useNavigate();
    const { tab } = useParams();
    const theme = useMantineTheme();

    return (
        <Tabs
            className='tabNavBar'
            radius={0}
            value={tab}
            onTabChange={(val) => navigate(`${stateNavigate}${val}`, { replace: true })}
            keepMounted={stateKeepMounted}

            sx={{
                backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[8],
            }}
        >
            <Box
                px='md'
            >
                <ScrollContainer
                    vertical={false}
                    horizontal={true}
                    hideScrollbars={true}

                    style={{
                        borderBottom: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7]}`,
                    }}
                >
                    <Tabs.List
                        sx={() => ({
                            flexWrap: 'nowrap',
                            borderBottomColor: 'transparent',
                            '& button': {
                                paddingTop: '1.25rem',
                                paddingBottom: '1.25rem',
                                transition: '200ms',

                                '&:hover': {
                                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7]
                                }
                            }
                        })}
                    >
                        {children}
                    </Tabs.List>
                </ScrollContainer>
            </Box>
        </Tabs>
    )
}

export default WrapperTab;